import { render, staticRenderFns } from "./TagMenuButton.vue?vue&type=template&id=ced888b2&scoped=true"
import script from "./TagMenuButton.vue?vue&type=script&lang=js"
export * from "./TagMenuButton.vue?vue&type=script&lang=js"
import style0 from "./TagMenuButton.vue?vue&type=style&index=0&id=ced888b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced888b2",
  null
  
)

export default component.exports